import React, { createContext } from 'react';

export const PhotoboothContext = createContext<any>({});
export const usePhotoboothContext = () => React.useContext(PhotoboothContext);
